/* Component to display a Tracket item */
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import { axiosReq, axiosInstance } from "../../api/axiosDefaults"
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PostDropdown } from "../../components/PostDropdown"
import styles from "../../styles/Indexes.module.css"
import ProTrackerEdit from "./ProTrackerEdit"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import toast from "react-hot-toast";
import ProTrackStatEdit from "./ProTrackStatEdit";

const ProTracker = (props) => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const [showEdit, setShowEdit] = useState(false)
  const [showStat, setShowStat] = useState(false)
  const { setHasOrder, tracker, setproTrackers } = props

  const {
    id,
    scene_number,
    name,
    department,
    level,
    status,
    done_by,
  } = tracker
  const displayNumber = scene_number ?? ""
  const displayDoneBy = done_by ?? ""
  const effectiveStatus = status ?? ""
  const handleEdit = () => {
    setShowEdit(true)
  }

  const handleDelete = async () => {
    // DELETE contract:
    // - endpoint: /production-tracker/items/{id}/
    // - payload: none
    // On success we update local paginated state (results + count) immediately.
    try {
      let response
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        response = await axiosReq.delete(`/production-tracker/items/${id}/`)
      } else {
        response = await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/production-tracker/items/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
      }
      if (response?.success === false) {
        throw response.error
      }

      setproTrackers((prevTracks) => {
        const prevCount = prevTracks?.count ?? prevTracks?.results?.length ?? 0
        return {
          ...prevTracks,
          count: Math.max(prevCount - 1, 0),
          results: prevTracks.results.filter((track) => track.id !== id),
        }
      })
      setHasOrder(true)
      toast.success(`Tracker Item Deleted Successfully!`);
    } catch (err) {
      console.log(err)
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        "Failed to delete tracker item."
      toast.error(backendError)
    }
  }
       
  return (
    <div className={`${styles.TrackBold}`}>
      {/* Status Update */}
        {!showStat ? (
          ""
        ) : (
          <ProTrackStatEdit
            id={id}
            tracker={tracker}
            status1={effectiveStatus}
            setShowStat={setShowStat}
            setproTrackers={setproTrackers}
          />
        )}
      <div className="d-none d-md-block">
        <Row className={`py-0 ${styles.White }`}>
        {/* status   */}
        {effectiveStatus === "new" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.New}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.New}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* started */}
        {effectiveStatus === "started" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.Started}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.Started}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* new done  */}
        {effectiveStatus === "done" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.Done}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={1}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.Done}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* item */}
        <Col xs={4} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border3}`}>
        <p className={` ${styles.BoldScene}`}>{name}</p>
        </Col>
         {/* scene number */}
        <Col xs={1} className={`mx-0 px-0 d-flex align-items-center justify-content-center
           ${styles.Border2}`}>
        <p className={` ${styles.Role}`}>{displayNumber}</p>
        </Col>
        {/* department */}
        {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") ? (
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center
           ${styles.CastCall}`} xs={2}>
        <p className={`text-capitalize ${styles.Div30AD}`}>{department}</p>
        </Col>
        ) : (
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center
           ${styles.CastCall}`} xs={3}>
        <p className={`text-capitalize ${styles.Div30AD}`}>{department}</p>
        </Col>
        )}
        {/* level   */}
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center
           ${styles.Border2}`} xs={1}>
        <p className={`text-capitalize ${styles.Role}`}>{level}</p>
        </Col>
        {/* done by */}
        <Col className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border2}`} xs={2}>
        <p style={{ fontStyle: 'italic'}} className={` ${styles.Div30A}`}>{displayDoneBy}</p>
        </Col>
        {/* edit */}
        {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") ? (
        <Col xs={1} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border3}`}>       
        <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                />
        </Col>) : ("") }
        </Row>
      </div>
      <div className={`d-block d-md-none ${styles.BottomScene}`}>
        <Row className={`py-0`} >
          {/* scene number */}
        <Col xs={3} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border2}`}>
        <p className={` ${styles.Role}`}>{displayNumber}</p>
        </Col>
        {/* item */}
        <Col  xs={6} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border3}`}>
        <p className={` ${styles.BoldScene}`}>{name}</p>
        </Col>
        {/* department */}
        <Col xs={3} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.CastCall}`}>
        <p className={`text-capitalize ${styles.Role}`}>{department}</p>
        </Col>
        </Row>
        <Row className={`py-0`} >
        {/* due by  */}
        <Col xs={4} className={`mx-0 px-0 d-flex align-items-center justify-content-center`} >
        <p style={{ fontStyle: 'italic'}} className={` ${styles.Div30M}`}>{displayDoneBy}</p>
        </Col>
        {/* status   */}
        {effectiveStatus === "new" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.NewM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.NewM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* started */}
        {effectiveStatus === "started" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.StartedM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.StartedM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* new done  */}
        {effectiveStatus === "done" ? (
            <>
            {(currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin" ||
                currentUser?.groups[0]?.name === "Admincreative")
            ? (
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Update Status</Tooltip>}>
                <Col onClick={() => setShowStat((showStat) => !showStat)}
                className={`mx-0 px-0 ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.DoneM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
                </Col>
                </OverlayTrigger>
            ) : (
              <Col className={`mx-0 px-0
                ${styles.Border2} py-2`} xs={4}>
                <div className={`mx-0 px-0 d-flex align-items-center justify-content-center
                ${styles.DoneM}`}>
                <p className={`text-capitalize ${styles.Titlelist}`}>{effectiveStatus}</p>
                </div>
              </Col>
            )}
          </>
        ) : (
          ""
        )}
        {/* level  */}
        {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") ? (
        <Col xs={3} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.BorderM}`}>
        <p style={{ fontStyle: 'italic', textTransform: 'capitalize'}} className={`text-capitalize ${styles.Div30M}`}>{level}</p>
        </Col>
        ) : (
        <Col  xs={4} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border2M}`} >
        <p style={{ fontStyle: 'italic', textTransform: 'capitalize'}} className={`text-capitalize ${styles.Div30M}`}>{level}</p>
        </Col>
        )}
        {/* edit */}
        {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") ? (
        <Col xs={1} className={`mx-0 px-0 d-flex align-items-center justify-content-center ${styles.Border3M}`}>       
        <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                />
        </Col>) : ("") }
        </Row>
      </div>
      {!showEdit ? (
        ""
      ) : (
        <ProTrackerEdit
          setproTrackers={setproTrackers}
          tracker={tracker}
          id={id}
          setShowEdit={setShowEdit}
          setHasOrder={setHasOrder}
        />
      )}
    </div>
  )
}

export default ProTracker
